import { 
	defineStore
} from 'pinia'

import { 
	useStorage
} from '@vueuse/core'

// types
import { 
	System
} from '@/types'

export const store = defineStore('system', {

	state: () => ({ // a function that returns a fresh state
        system: useStorage('system', {
			primaryRoute: "Dashboard",
			sidebarExpanded: true
        } as System)
	}),
	
	getters: { // optional getters
	},

	actions: { // optional actions

	}
})